<template>
  <v-list-item v-if="person" color="primary">
    <v-list-item-avatar size="32">
      <v-img v-if="profilePhoto" contain :src="profilePhoto"></v-img>
      <v-img v-else contain src="@/assets/images/NoPhotoIcon.png"></v-img>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title v-if="person.firstName" class="label-m">
        {{
          person.isInterimPresentor
            ? person.firstName
            : person.firstName + " " + person.lastName
        }}
      </v-list-item-title>
      <v-list-item-title v-else class="label-m">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on" v-bind="attrs" class="label-m">
              {{ person.email }}</span
            >
          </template>
          {{ person.email }}
        </v-tooltip>
      </v-list-item-title>
      <v-list-item-subtitle class="label-s">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on" v-bind="attrs" class="label-s">{{
              person.title
            }}</span>
          </template>
          {{ person.title }}
        </v-tooltip>
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>
<script>
export default {
  name: "MeetingPresentor",
  data() {
    return {};
  },
  props: {
    person: { type: Object, default: null },
  },
  computed: {
    profilePhoto() {
      if (!this.person) {
        return null;
      }
      return this.person.profilePhoto;
    },
  },
};
</script>

<style  scoped>
::v-deep .v-list-item {
  padding: 0px !important;
}
</style>